import { render, staticRenderFns } from "./Promotion_edit_pos_price.vue?vue&type=template&id=28fafe54&scoped=true&"
import script from "./Promotion_edit_pos_price.vue?vue&type=script&lang=js&"
export * from "./Promotion_edit_pos_price.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_edit_pos_price.vue?vue&type=style&index=0&id=28fafe54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fafe54",
  null
  
)

export default component.exports